<p>purchase-course-details works!</p>
